import React, { useState, useEffect } from 'react';
import { WithStyles, ClassNameMap } from '@mui/styles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { Grid } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

import Dashboard from '../../../layouts/Dashboard';
import GridCard from '../../../components/Grid/GridCard';

import styles from './styles';
import { homeInitQuery, Counters } from './queries';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const HomeArea = ({ classes, history }: Props): React.ReactElement => {
  const [counters, setCounters] = useState<Counters>({
    area_sections_aggregate: { aggregate: { count: 0 } },
    events_aggregate: { aggregate: { count: 0 } },
    era_care_events_aggregate: { aggregate: { count: 0 } },
    missing_patients_info: { aggregate: { count: 0 } },
  });

  const { data: homeInitData } = useQuery(homeInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && homeInitData) {
      setCounters({
        ...homeInitData,
      });
    }
    return () => {
      mounted = false;
    };
  }, [homeInitData]);

  const handleAction = (link: string) => {
    history.push(link);
  };

  const actions = [
    {
      title: 'Wards',
      createLink: '/department/wards/create',
      viewLink: '/department/wards',
      counter: counters.area_sections_aggregate.aggregate.count,
    },
    {
      title: 'Reports',
      viewLink: '/department/reports',
      counter: counters.events_aggregate.aggregate.count,
    },
    {
      title: 'Nurtura',
      viewLink: '/department/care-events',
      counter: counters.era_care_events_aggregate.aggregate.count,
    },
  ];

  return (
    <Dashboard title="Dashboard">
      <Grid container spacing={4}>
        {actions.map((action) => (
          <GridCard
            key={action.title}
            title={action.title}
            counter={action.counter}
            editLabel="Create"
            handleEdit={action.createLink ? () => handleAction(action.createLink) : undefined}
            handleView={() => handleAction(action.viewLink)}
          />
        ))}
      </Grid>
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(HomeArea));
